export default "__VITE_ASSET__CnXv3o79__"